import React, { useState, useEffect } from 'react';
import {
  TextField,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  Grid,
  CircularProgress,
  Box,
} from '@material-ui/core';

import {
  IReasonOccurrence,
  useReasonOccurrence,
} from '../../hooks/reason-occurrence';

interface IProps {
  open: boolean;
  occurrenceId: number | null;
  onClose: () => void;
}

export const ReasonOccurrenceInfo: React.FC<IProps> = (props) => {
  const { loadReasonOccurrenceById } = useReasonOccurrence();
  const [occurrence, setOccurrence] = useState<IReasonOccurrence>(
    {} as IReasonOccurrence
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props.open) {
      setOccurrence({} as IReasonOccurrence);
      setLoading(true);
    }
  }, [props.open]);

  useEffect(() => {
    async function loadOccurrence(): Promise<void> {
      if (props.occurrenceId) {
        try {
          const response = await loadReasonOccurrenceById(props.occurrenceId);

          if (!response) return;

          setOccurrence(response);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      }
    }

    loadOccurrence();
  }, [loadReasonOccurrenceById, props.occurrenceId]);

  return (
    <Dialog
      maxWidth="sm"
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Informações</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ marginBottom: 32 }}>
          Motivo de Ocorrência:
        </DialogContentText>
        {loading ? (
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <Box alignItems="center" justifyContent="center">
              <CircularProgress />
            </Box>
          </Grid>
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                label="Motivo"
                value={occurrence.reason ?? 'Não informado'}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                label="Descrição"
                multiline
                minRows={2}
                maxRows={5}
                value={occurrence.description ?? 'Não informado'}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={props.onClose} color="inherit">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
